import { render, staticRenderFns } from "./mask-checked.vue?vue&type=template&id=4db5ef5c&scoped=true"
import script from "./mask-checked.vue?vue&type=script&lang=js"
export * from "./mask-checked.vue?vue&type=script&lang=js"
import style0 from "./mask-checked.vue?vue&type=style&index=0&id=4db5ef5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db5ef5c",
  null
  
)

export default component.exports